import { render, staticRenderFns } from "./sub.vue?vue&type=template&id=369e673a"
import script from "./sub.vue?vue&type=script&lang=ts"
export * from "./sub.vue?vue&type=script&lang=ts"
import style0 from "./sub.vue?vue&type=style&index=0&id=369e673a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports